<form class="availability-page" [formGroup]="availabilityForm">
  <div class="availability-header">
    <div class="tabs">
        <button type="button" [class.active]="activeTab === 'weekly'" (click)="showTab('weekly')">
        Modello Settimanale
        </button>

        <button type="button" [class.active]="activeTab === 'special'" (click)="showTab('special')">
        Date Speciali
        </button>

        <button type="button" [class.active]="activeTab === 'calendar'" (click)="showTab('calendar')">
        Calendario
        </button>
    </div>

    <button
      type="button"
      class="btn btn-primary"
      [disabled]="saving"
      (click)="saveAvailability()"
    >
      {{ saving ? 'Salvataggio...' : 'Salva Disponibilità' }}
    </button>
  </div>

  <div class="empty" *ngIf="loading">
    Caricamento disponibilità...
  </div>

  <section class="card" *ngIf="!loading && activeTab === 'weekly'" formArrayName="weekly">
    <div class="card-header">
      <h3>Modello Settimanale</h3>
      <p>Programmazione normale ripetuta. Aggiungi solo le fasce orarie disponibili.</p>
    </div>

    <div class="content">
      <div class="days-grid">
        <button
          type="button"
          class="day-btn"
          *ngFor="let day of days"
          [class.active]="selectedDay === day.dayOfWeek"
          (click)="selectWeeklyDay(day.dayOfWeek)"
        >
          {{ day.label }}
          <br />
          <small>
            {{
              weeklyArray.at(day.dayOfWeek - 1).get('isClosed')?.value
                ? 'Chiuso'
                : (weeklyArray.at(day.dayOfWeek - 1).get('slots')?.value?.length || 0) + ' fascia/e'
            }}
          </small>
        </button>
      </div>

      <div [formGroupName]="selectedDay - 1">
        <div class="editor-top">
          <div>
            <h3>{{ selectedDayName }}</h3>
            <p>
              {{
                selectedWeeklyGroup.get('isClosed')?.value
                  ? 'Chiuso tutto il giorno'
                  : selectedWeeklySlots.length + ' fascia/e disponibili'
              }}
            </p>
          </div>

          <div class="weekly-actions">
            <div class="copy-day-box">
              <select
                [(ngModel)]="copyFromDayOfWeek"
                [ngModelOptions]="{ standalone: true }"
              >
                <option [ngValue]="null">Copia fasce da...</option>

                <option
                  *ngFor="let day of days"
                  [ngValue]="day.dayOfWeek"
                  [disabled]="day.dayOfWeek === selectedDay"
                >
                  {{ day.name }}
                </option>
              </select>

              <button
                type="button"
                class="btn btn-light"
                [disabled]="!copyFromDayOfWeek"
                (click)="copyWeeklySlotsFromDay()"
              >
                Copia
              </button>

              <button type="button" class="btn btn-light" (click)="addWeeklySlot()">
                + Aggiungi Fascia
              </button>
            </div>
          </div>
        </div>

        <label class="closed-box">
          <input
            type="checkbox"
            [checked]="selectedWeeklyGroup.get('isClosed')?.value"
            (change)="setWeeklyClosed($any($event.target).checked)"
          />
          Chiuso tutto il giorno
        </label>

        <div class="slot-list" formArrayName="slots" *ngIf="!selectedWeeklyGroup.get('isClosed')?.value">
          <div
            class="slot-row"
            *ngFor="let slot of selectedWeeklySlots.controls; let i = index"
            [formGroupName]="i"
          >
            <div class="field">
              <label>Ora di inizio</label>
              <input type="time" formControlName="start" />
            </div>

            <div class="field">
              <label>Ora di fine</label>
              <input type="time" formControlName="end" />
            </div>

            <button type="button" class="btn btn-danger remove-btn" (click)="removeWeeklySlot(i)">
              ×
            </button>
          </div>
        </div>

        <div class="empty" *ngIf="selectedWeeklyGroup.get('isClosed')?.value">
          Questo giorno è chiuso.
        </div>

        <div
          class="empty"
          *ngIf="!selectedWeeklyGroup.get('isClosed')?.value && selectedWeeklySlots.length === 0"
        >
          Nessuna fascia oraria aggiunta.
        </div>
      </div>
    </div>
  </section>

  <section class="card" *ngIf="!loading && activeTab === 'special'">
    <div class="card-header">
      <h3>Date Speciali</h3>
      <p>Da usare per festività, ferie o orari di lavoro personalizzati.</p>
    </div>

    <div class="special-layout">
      <aside class="special-sidebar">
        <div class="special-create">
          <div class="field">
            <label>Aggiungi Data Speciale</label>
            <input
              type="date"
              [(ngModel)]="newOverrideDate"
              [ngModelOptions]="{ standalone: true }"
            />
          </div>

          <button type="button" class="btn btn-primary" (click)="addOverride()">
            + Aggiungi Data
          </button>
        </div>

        <div class="special-list">
          <div
            class="special-item"
            *ngFor="let item of overridesArray.controls; let i = index"
            [class.active]="selectedOverrideIndex === i"
            (click)="selectOverride(i)"
          >
            <strong>{{ item.get('date')?.value }}</strong>

            <span>
              {{
                item.get('isClosed')?.value
                  ? 'Chiuso tutto il giorno'
                  : (item.get('slots')?.value?.length || 0) + ' fascia/e'
              }}
            </span>

            <span>{{ item.get('note')?.value || 'Nessuna nota' }}</span>
          </div>

          <div class="empty" *ngIf="!overridesArray.length">
            Nessuna data speciale aggiunta.
          </div>
        </div>
      </aside>

      <div class="special-editor" formArrayName="overrides" *ngIf="selectedOverrideGroup">
        <div [formGroupName]="selectedOverrideIndex">
          <div class="editor-top">
            <div>
              <h3>{{ selectedOverrideGroup.get('date')?.value }}</h3>
              <p>Eccezione per data speciale</p>
            </div>

            <button type="button" class="btn btn-danger" (click)="deleteOverride()">
              Elimina
            </button>
          </div>

          <div class="meta-grid">
            <div class="field">
              <label>Data</label>
              <input
                type="date"
                formControlName="date"
                (change)="updateOverrideDate($any($event.target).value)"
              />
            </div>

            <div class="field">
              <label>Nota</label>
              <input
                type="text"
                formControlName="note"
                placeholder="Festività, ferie, orari personalizzati..."
                (change)="refreshCalendarEvents()"
              />
            </div>
          </div>

          <label class="closed-box">
            <input
              type="checkbox"
              [checked]="selectedOverrideGroup.get('isClosed')?.value"
              (change)="setOverrideClosed($any($event.target).checked)"
            />
            Chiuso tutto il giorno
          </label>

          <button
            type="button"
            class="btn btn-light"
            *ngIf="!selectedOverrideGroup.get('isClosed')?.value"
            (click)="addOverrideSlot()"
          >
            + Aggiungi Fascia
          </button>

          <div
            class="slot-list"
            formArrayName="slots"
            *ngIf="!selectedOverrideGroup.get('isClosed')?.value"
          >
            <div
              class="slot-row"
              *ngFor="let slot of selectedOverrideSlots.controls; let i = index"
              [formGroupName]="i"
            >
              <div class="field">
                <label>Ora di inizio</label>
                <input type="time" formControlName="start" (change)="refreshCalendarEvents()" />
              </div>

              <div class="field">
                <label>Ora di fine</label>
                <input type="time" formControlName="end" (change)="refreshCalendarEvents()" />
              </div>

              <button type="button" class="btn btn-danger remove-btn" (click)="removeOverrideSlot(i)">
                ×
              </button>
            </div>
          </div>

          <div class="empty" *ngIf="selectedOverrideGroup.get('isClosed')?.value">
            Questa data speciale è chiusa.
          </div>

          <div
            class="empty"
            *ngIf="!selectedOverrideGroup.get('isClosed')?.value && selectedOverrideSlots.length === 0"
          >
            Nessuna fascia oraria aggiunta per questa data speciale.
          </div>
        </div>
      </div>

      <div class="special-editor" *ngIf="!selectedOverrideGroup">
        <div class="empty">
          <ng-container *ngIf="newOverrideDate; else noSpecialDateSelected">
            Data selezionata: <strong>{{ newOverrideDate }}</strong>.
            Clicca su "+ Aggiungi Data" per creare una nuova data speciale.
          </ng-container>

          <ng-template #noSpecialDateSelected>
            Seleziona o aggiungi una data speciale.
          </ng-template>
        </div>
      </div>
    </div>
  </section>

  <section class="card" *ngIf="!loading && activeTab === 'calendar'">
    <div class="card-header">
      <h3>Vista Calendario</h3>
      <p>Clicca su una data per creare o modificare un'eccezione per una data speciale.</p>
    </div>

    <div class="content">
      <full-calendar [options]="calendarOptions"></full-calendar>
    </div>
  </section>

  <div class="availability-actions" *ngIf="!loading">
    <button type="button" class="btn btn-light" (click)="loadAvailability()">
      Ripristina
    </button>

    <button
      type="button"
      class="btn btn-primary"
      [disabled]="saving"
      (click)="saveAvailability()"
    >
      {{ saving ? 'Salvataggio...' : 'Salva Disponibilità' }}
    </button>
  </div>
</form>